import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MAIN_BLUE } from '../../espace-pro-app/src/constants/admin-theme';

const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${(props) => (props.containerHeight ? `${props.containerHeight}` : 'auto')};
`;

const Loader = (props) => {
  const { width, height, size, color, containerHeight } = props;
  const splitWidth = (width / 2) * size;
  const splitHeight = (height / 2) * size;

  return (
    <LoaderContainer containerHeight={containerHeight}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid"
        viewBox={`0  0 ${width * size} ${height * size}`}
        height={height}
        width={width}
      >
        <circle
          cx={splitWidth}
          cy={splitHeight}
          r="6"
          style={{
            fill: 'none',
            stroke: color,
            strokeWidth: '1',
            strokeDasharray: '18.84955592153876 8.283185307179586',
          }}
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            calcMode="linear"
            values={`0 ${splitWidth} ${splitHeight};360 ${splitWidth} ${splitHeight}`}
            keyTimes="0;1"
            dur="0.8s"
            begin="0s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    </LoaderContainer>
  );
};

Loader.propTypes = {
  containerHeight: PropTypes.string,
  size: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

Loader.defaultProps = {
  containerHeight: undefined,
  size: 0.5,
  width: 50,
  height: 50,
  color: MAIN_BLUE,
};

export { Loader };
